/* SVD mobilmeny — X-knappen, Escape-scroll-låset, tryck-feedback och direktöppnad
   undermeny. Skapad av Claude Code.
   Duplicerar ingen logik: X:et vidarebefordrar till temats egen stängning och
   undermenyn använder temats egna klasser (.menu-opening/.submenu-open). */
(function () {
  'use strict';

  /* Ytor som ska se nedtryckta ut — håll i synk med .svd-mm-pressed i CSS:en. */
  var PRESSABLE = '.svd-mm-row, .svd-mm-hero, .svd-mm-best, .svd-mm-promo--compact,' +
    '.svd-mm-promo__btn, .svd-mm-more-row, .svd-mm-cta, .parent-link-back--button,' +
    '.svd-mm-close';

  // Klick på X = klick på hamburgaren → header.js egen stängning körs,
  // inklusive scroll-låset och stängningsanimationen.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.svd-mm-close');
    if (!btn) return;
    var wrapper = btn.closest('.mobile-toggle-wrapper');
    var toggle = wrapper && wrapper.querySelector('.mobile-toggle');
    if (toggle) toggle.click();
  });

  // Temabugg: header.js Escape-hanterare stänger menyn men släpper aldrig
  // scroll-låset på body — med en fullscreen-meny blir hela sidan död.
  // Capture-fas så guarden hinner se att menyn var öppen innan header.js
  // (bubble-fas) tagit bort open/active.
  document.addEventListener('keyup', function (e) {
    if (!e.code || e.code.toUpperCase() !== 'ESCAPE') return;
    if (document.querySelector('.mobile-toggle-wrapper[open].active')) {
      document.body.classList.remove('overflow-hidden');
    }
  }, true);

  /* ---------- Tryck-feedback (2026-09-18) ----------
     Raderna hade ingen :active-stil alls — ett tryck såg dött ut ända tills
     nästa sida eller undermeny dök upp. Klassen sätts på pointerdown i stället
     för att luta sig mot :active, som iOS Safari bara ger åt vissa element och
     som dessutom blir hängande när man drar i listan för att scrolla. */
  var pressed = null;
  var releaseTimer = null;
  var navigating = false;

  function release() {
    if (navigating) return; // raden ska se nedtryckt ut tills sidan byts
    clearTimeout(releaseTimer);
    releaseTimer = null;
    if (!pressed) return;
    pressed.classList.remove('svd-mm-pressed');
    pressed = null;
  }

  // Ett snabbt tap ger annars bara ~40 ms nedtryckt läge = knappt synligt.
  function scheduleRelease() {
    if (!pressed || releaseTimer) return;
    releaseTimer = setTimeout(release, 90);
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.button > 0) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var el = t.closest(PRESSABLE);
    if (!el || !el.closest('.svd-mm')) return;
    release();
    pressed = el;
    el.classList.add('svd-mm-pressed');
  }, { capture: true, passive: true });

  document.addEventListener('pointerup', scheduleRelease, true);
  // Scroll börjar → webbläsaren skickar pointercancel. Scroll-lyssnaren är
  // hängslena för de fall den uteblir; båda släpper direkt, utan minsta tid.
  document.addEventListener('pointercancel', release, true);
  document.addEventListener('scroll', release, true);

  /* ---------- Sidan hämtas (2026-09-18) ----------
     Menyraderna leder rakt till en ny sida, och temat behöver ~1,5–2 s på en
     telefon innan något målas. Utan besked står menyn kvar och ser frusen ut.
     Raden blir därför kvar i nedtryckt läge och en tunn linje löper under
     X-raden tills navigeringen sker. Släpps vid pagehide/pageshow så att
     bakåtknappen (bfcache) inte möts av en meny som fortfarande laddar. */
  var navTimer = null;

  function stopLoading() {
    clearTimeout(navTimer);
    navTimer = null;
    navigating = false;
    var menu = document.querySelector('.svd-mm--loading');
    if (menu) menu.classList.remove('svd-mm--loading');
    release();
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href]');
    if (!a) return;
    var menu = a.closest('.svd-mm');
    if (!menu) return;
    if (a.target && a.target !== '_self') return;
    if (a.getAttribute('href').charAt(0) === '#') return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    if (url.href === location.href) return;

    navigating = true;
    menu.classList.add('svd-mm--loading');
    // Säkerhetsventil: blir det ingen navigering ska menyn inte fastna i laddläge.
    clearTimeout(navTimer);
    navTimer = setTimeout(stopLoading, 8000);
  });

  window.addEventListener('pagehide', stopLoading);
  window.addEventListener('pageshow', stopLoading);

  /* ---------- Undermenyn öppnas direkt (2026-09-18) ----------
     header.js väntar 100 ms innan .menu-opening sätts, för att <details> ska
     hinna rendera undermenyn i sitt startläge (translateX(100%)) — annars
     hoppar den in utan att glida. toggle-eventet ger samma garanti utan
     väntan: där är open redan satt, och en framtvingad reflow committar
     startläget innan klassen läggs på. header.js:s timeout sätter sedan samma
     klass en gång till, vilket inte gör något. toggle bubblar inte → capture. */
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!details || !details.classList) return;
    if (!details.open || !details.classList.contains('link-container')) return;
    if (!details.closest('.svd-mm')) return;
    var sub = details.querySelector(':scope > .sub-menu');
    if (sub) void sub.offsetWidth; // tvingar fram startläget före transitionen
    details.classList.add('menu-opening');
    details.classList.add('submenu-open');
  }, true);
})();
